import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { StatusCodeToError } from 'components/ordering/rma/api/dtos/error.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type UpdateRmaCommentPayload = {
  rmaId: string
  comment: string | null
}

export class UpdateRmaComment extends RmaRequest<null, ExpectedErrors> {
  path: string
  override expectedErrors = EXPECTED_ERRORS
  override init: RequestInit

  constructor({ rmaId, comment }: UpdateRmaCommentPayload) {
    super()
    this.path = `account/rma/draft/update/${rmaId}/`
    this.init = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ comment }),
    }
  }
}
